import moment from "moment";

//Text Sorter
const textSorter = (valA, valB) => {
    const strA = valA?.toString().toLowerCase() || "";
    const strB = valB?.toString().toLowerCase() || "";
    return strA.localeCompare(strB);
};

//Number Sorter
const numberSorter = (valA, valB) => {
    const numA = parseFloat(valA);
    const numB = parseFloat(valB);
    if (isNaN(numA) || isNaN(numB)) return 0;
    return numA - numB;
};

//Date Sorter
const dateSorter = (valA, valB, format = "DD-MM-YYYY", strict = true) => {
    const rawA = valA?.toString().trim() || "";
    const rawB = valB?.toString().trim() || "";

    const isEmptyA = rawA === "";
    const isEmptyB = rawB === "";

    if (isEmptyA && !isEmptyB) return -1;
    if (!isEmptyA && isEmptyB) return 1;
    if (isEmptyA && isEmptyB) return 0;

    const dateA = moment(rawA, format, strict);
    const dateB = moment(rawB, format, strict);

    if (!dateA.isValid() || !dateB.isValid()) return 0;
    if (dateA.isBefore(dateB)) return -1;
    if (dateA.isAfter(dateB)) return 1;
    return 0;
};

//Custom Code Sorter
const customSorter = (valA, valB) => {
    const extractNumber = (val) => {
        if (!val) return NaN;
        const match = val.match(/-(\d+)(?=\/)/);
        return match ? parseInt(match[1], 10) : NaN;
    };

    const numA = extractNumber(valA);
    const numB = extractNumber(valB);

    if (isNaN(numA) || isNaN(numB)) return 0;
    return numA - numB;
};

//Main Sorter Selector
// `strict` (date only): pass false to parse loosely when values don't match `format` exactly
export const filterTableSorter = (key, type = "text", format, strict = true) => (a, b) => {
    const valA = a[key];
    const valB = b[key];

    switch (type) {
        case "text":
            return textSorter(valA, valB);
        case "number":
            return numberSorter(valA, valB);
        case "date":
            return dateSorter(valA, valB, format, strict);
        case "customCode":
            return customSorter(valA, valB);
        default:
            return null;
    }
};